__turbopack_context__.v({
  "addToCart": "GiftForm-module__Jf70Oa__addToCart",
  "cardsColumn": "GiftForm-module__Jf70Oa__cardsColumn",
  "cardsStack": "GiftForm-module__Jf70Oa__cardsStack",
  "oneTimeNote": "GiftForm-module__Jf70Oa__oneTimeNote",
  "optionsFieldset": "GiftForm-module__Jf70Oa__optionsFieldset",
  "optionsLayout": "GiftForm-module__Jf70Oa__optionsLayout",
  "optionsLayoutSplit": "GiftForm-module__Jf70Oa__optionsLayoutSplit",
  "root": "GiftForm-module__Jf70Oa__root",
  "valueProps": "GiftForm-module__Jf70Oa__valueProps",
  "valuePropsHeading": "GiftForm-module__Jf70Oa__valuePropsHeading",
  "valuePropsList": "GiftForm-module__Jf70Oa__valuePropsList",
  "valuePropsParagraph": "GiftForm-module__Jf70Oa__valuePropsParagraph",
});
